import React from 'react'
import ContactPage from '../Components/ContactPage'

const Contact = () => {
    return (
        <>
        <ContactPage/>
        </>
    )
}

export default Contact
